module.exports = __webpack_public_path__ + "static/media/1020057.f667fe89.png";